export var switchTenantActions = {
    SHOW_SWITCH_TENANT_BUTTON: 'SHOW_SWITCH_TENANT_BUTTON',
    HIDE_SWITCH_TENANT_BUTTON: 'HIDE_SWITCH_TENANT_BUTTON',
};



//////////////////
// WEBPACK FOOTER
// ./src/actions/switchTenantActions.ts
// module id = 40
// module chunks = 0